import React from "react";
import SVGFoundation from "../../../svg-foundation/svg-foundation";
export default class Play extends SVGFoundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
            titleText: void 0,
        };
    }
    render() {
        return (React.createElement("svg", Object.assign({}, this.unhandledProps()),
            this.renderTitleText(this.props),
            React.createElement("path", { 
                /* tslint:disable-next-line */
                d: "M24.5 14L7 26.25V1.75L24.5 14ZM8.75 22.8867L21.4512 14L8.75 5.11328V22.8867Z" })));
    }
}
Play.defaultProps = {
    viewBox: "0 0 28 28",
    width: "28px",
    height: "28px",
    xmlns: "http://www.w3.org/2000/svg",
};
